
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"<WARNING>_one":"Warnung","<WARNING>_other":"{{count}} Warnungen","<ERROR>_one":"Fehler","<ERROR>_other":"{{count}} Fehler","<INFO>_one":"Information","<INFO>_other":"{{count}} Informationen"},"en":{"<WARNING>_one":"Warning","<WARNING>_other":"{{count}} Warnings","<ERROR>_one":"Error","<ERROR>_other":"{{count}} Errors","<INFO>_one":"Information","<INFO>_other":"{{count}} Information"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();